<template>
  <div class="mag-t10">
    <van-pull-refresh v-model="isLoading" @refresh="$parent.setrecord === 0 ? getPointInfo() : getPointApplyInfo()">
      <div ref="fresh" :style="{height:freshHeight +'px','overflow-y':'scroll','box-sizing': 'border-box','padding-bottom':'100px'}">
        <van-checkbox-group ref="checkboxGroup" v-model="result">
          <!-- :disabled="$parent.setrecord === 0 ? true : false " -->
          <van-swipe-cell
            v-for="(info, index) in workLeaves"
            :key="index"
          >
            <van-cell class="bor-bom" @click="IntegralDescription(info)">
              <template #title>
                <span v-if="$parent.setrecord === 0">{{ info.user_name }}</span>
                <span v-else>申请对象：{{ info.user_name }}</span>
              </template>
              <template slot="label">
                <font v-if="$parent.setrecord === 0" class="font-s10">{{ info.point_date }}</font>
                <font v-else class="font-s10">{{ info.apply_date }}</font>
              </template>
              <span>
                <font class="font-s10 white-space">{{ info.content }}</font>
              </span>
              <br>
              <span>
                <font
                  v-if="$parent.setrecord === 0"
                  class="font-s10"
                  :style="{ color: leaveStatusSet(info.score)}"
                >积分数：{{ info.score }}
                </font>
                <span v-else>
                  <font
                    class="font-s10"
                    :style="{ color: ExamineColor(info.approval_status)}"
                  > {{ '(' + ExamineText(info.approval_status) + ')' }}
                  </font>
                  <font class="font-s10">{{ info.score }}</font>
                </span>
              </span>
            </van-cell>
            <template v-if="$parent.setrecord === 1" #right>
              <!-- 未审批 -->
              <van-button v-if="info.approval_status === '0'" square text="修改" type="primary" class="button-size" @click="toEducationalPointsApply(info,'modify')" />
              <van-button v-if="info.approval_status === '0'" square text="撤销" type="danger" class="button-size" @click="delPointApplyInfoDialog(info)" />
              <!-- 已拒绝 -->
              <van-button v-if="info.approval_status === '1'" square text="再申请" type="primary" class="button-size" @click="toEducationalPointsApply(info,'modify')" />
            </template>
          </van-swipe-cell>
        </van-checkbox-group>
      </div>
    </van-pull-refresh>
  </div>
</template>
<script>
import { GetPointInfo, GetPointApplyInfo, DelPointApplyInfo } from '@/api/EducationalPoints'
import { Dialog } from 'vant'
import { Notify } from 'vant'
export default {
  name: 'TableData',
  components: {
    [Dialog.Component.name]: Dialog.Component,
    [Notify.Component.name]: Notify.Component
  },
  data() {
    return {
      workLeaves: [],
      isLoading: false,
      freshHeight: '100%',
      result: [],
      checked: false,
      checkedAll: false
    }
  },
  watch: {
    // check全选
    result() {
      if (this.result.length === this.workLeaves.length) {
        this.checked = true
      } else {
        this.checked = false
      }
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    // 积分记录
    leaveStatusSet(val) {
      // 正数
      if (parseInt(val) > 0) {
        return 'green'
      // 负数
      } else {
        return 'red'
      }
    },
    // 申请记录颜色
    ExamineColor(val) {
      switch (val) {
        // 未审批
        case '0': return '#FAA755'
        // 已拒绝
        case '1': return '#FF0000'
        // 已审批
        case '2': return '#7FB80E'
      }
    },
    // 申请记录文字
    ExamineText(val) {
      switch (val) {
        // 未审批
        case '0': return '未审批'
        // 已拒绝
        case '1': return '已拒绝'
        // 已审批
        case '2': return '已审批'
      }
    },
    // 获取积分记录信息
    getPointInfo() {
      const parse = {}
      // 检索用户id
      parse.search_user_id = this.$store.getters.usercode
      // 检索日期开始日
      parse.search_date_f = this.$parent.Point_data_s
      // 检索日期结束日
      parse.search_date_t = this.$parent.Point_data_e
      const that = this
      GetPointInfo(parse, function(res) {
        if (res.code === 0) {
          that.workLeaves = JSON.parse(res.data)
        } else {
          that.workLeaves = []
        }
        that.isLoading = false
      })
    },
    // 积分说明
    IntegralDescription(info) {
      Dialog.alert({
        title: '积分说明',
        message: info.content,
        theme: 'round-button'
      }).then(() => {
        // on close
      })
    },
    // 获取积分申请信息
    getPointApplyInfo() {
      const parse = {}
      parse.search_user_id = this.$store.getters.usercode
      parse.search_date_f = this.$parent.Point_data_s
      parse.search_date_t = this.$parent.Point_data_e
      const that = this
      GetPointApplyInfo(parse, function(res) {
        if (res.code === 0) {
          that.workLeaves = JSON.parse(res.data)
        } else {
          that.workLeaves = []
        }
        that.isLoading = false
      })
    },
    // 删除积分申请信息Dialog
    delPointApplyInfoDialog(val) {
      Dialog.confirm({
        title: '警告',
        message: '删除后无法恢复，确定要删除吗?'
      })
        .then(() => {
          this.delPointApplyInfo(val)
        })
        .catch(() => {
          // on cancel
        })
    },
    // 删除积分申请信息
    delPointApplyInfo(val) {
      const that = this
      DelPointApplyInfo({ id: val.id }, function(res) {
        if (res.code === 0) {
          Notify({ type: 'success', message: '删除成功', duration: 1000 })
          // 获取积分记录信息
          that.getPointApplyInfo()
          // 获取当前可用积分数
          that.$emit('getPointSum', that.$store.getters.usercode)
        } else {
          Notify({ type: 'danger', message: '删除失败', duration: 1000 })
        }
      })
    },
    // 跳转EducationalPointsApply
    toEducationalPointsApply(val, flg) {
      this.$router.push(
        { name: 'EducationalPointsApply', params: { data: val, flg: flg }}
      )
    }
  }
}
</script>
<style scoped>
.font-s10{
  font-size: 13px;
}
.score{
  font-size: 14px;
  font-weight: 600;
}
.bor-bom{
  border-bottom: 1px solid #EBEDF0;
  height: 66px;
}
.button-size{
    height: 100%;
}
.mar-rig16{
  margin-right: 16px;
}
.mag-t10{
  margin-top: 1px;
}
.white-space{
  white-space: nowrap;
  width: 80%;
}
</style>
